<template>
  <div id="detailCanvas" ref="detailCanvas" class="detailContent canvas-box">
    <div class="title">
      <div class="title-name">{{ $t('data.payout_details') }}
        <el-tag :type="getPOTransactionStatusType(merchantInfo.po_trans_status)" class="pay-status tag-custom"> {{ getPOTransactionStatusMap(merchantInfo.po_trans_status) }}</el-tag>
      </div>
    </div>
    <div class="detail-download-container">
      <div class="total">
        <div class="total-item">
          <div class="total-title">{{ $t('data.paid') }}:</div>
          <div class="total-num "> {{ $store.getters.currency }}  {{ merchantInfo.po_trans_amount | toDivideWithDot }}</div>
        </div>
        <div class="total-item">
          <div class="total-title">{{ $t('data.fee') }}:</div>
          <div class="total-num">{{ $store.getters.currency }}  {{ merchantInfo.fee_split | toDivideWithDot }}</div>
        </div>
      </div>
      <div class="section-title mb-12 mt-12">
        {{ $t('data.timeline') }}
      </div>
      <div class="line-bottom-1px" />
      <div class="item">
        <span class="item-left content-blue"> {{ $t('merchantAccount.create_time') }}</span>
        <span class="content-gray"> {{ merchantInfo.transaction_create_time }} </span>
      </div>

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.complete_time') }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_return_time }}</span>
      </div>

      <div class="section-title mb-12 mt-36">
        {{ $t('data.description') }}
      </div>
      <div class="line-bottom-1px" />

      <div class="item">
        <span class="item-left content-blue">{{ $t('merchantAccount.transaction_id') }}</span>
        <span class="content-gray">{{ merchantInfo.transaction_id }}</span>
      </div>

      <div class="item">
        <div class="item-left content-blue">{{ $t('customerService.remitting_bank') }}：</div>
        <div class="content-gray">{{ merchantInfo.sender_bank_name }}</div>
      </div>

      <div class="item">
        <div class="item-left content-blue">{{ $t('customerService.remittance_account') }}：</div>
        <div class="content-gray">{{ merchantInfo.sender_bank_account |strAesDecryptAndAsterisk }}</div>
      </div>

      <div class="item">
        <div class="item-left content-blue">{{ $t('merchantAccount.recipient_name') }}：</div>
        <div class="content-gray">{{ merchantInfo.recipient_name | strAesDecryptAndAsterisk }}</div>
      </div>
      <div class="item">
        <div class="item-left content-blue">{{ $t('merchantAccount.recipient_mobile') }}：</div>
        <div class="content-gray">{{ merchantInfo.recipient_mobile }}</div>
      </div>
      <div class="item">
        <div class="item-left content-blue">{{ $t('merchantAccount.recipient_channel') }}：</div>
        <div class="content-gray">{{ merchantInfo.recipient_channel }}</div>
      </div>
      <div class="item">
        <div class="item-left content-blue">{{ $t('merchantAccount.recipient_account') }}：</div>
        <div class="content-gray">{{ merchantInfo.recipient_account | strAesDecryptAndAsterisk }}</div>
      </div>
      <div class="item">
        <div class="item-left content-blue">{{ $t('data.remark') }}：</div>
        <div class="content-gray">{{ merchantInfo.product_name }}</div>
      </div>

      <div class="download-time mt-48">{{ $t('data.download_time') }}: {{ Date.now() | parseTime() }}</div>
    </div>

  </div>
</template>

<script>
import html2canvas from 'html2canvas'
import { poTransStatusMap } from '@/utils/maps'
export default {
  name: 'PayoutDetailDownload',
  props: {
    merchantInfo: {
      type: Object,
      default: function() {
        return {
          merchant: {
            merchant_basic_info: {}
          },
          disbursement_fee: {
          }
        }
      }
    }
  },
  computed: {
    getPOTransactionStatusType() {
      return function(value) {
        return poTransStatusMap(value).type
      }
    },
    getPOTransactionStatusMap() {
      return function(value) {
        return poTransStatusMap(value).label
      }
    }
  },
  methods: {
    saveImg() {
      const val = 'detailCanvas'
      window.pageYoffset = 0
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      const node = document.getElementById(val)

      const width = node.offsetWidth
      const height = node.offsetHeight
      const scale = 2
      html2canvas(node, {
        width: width,
        heigth: height,
        backgroundColor: '#ffffff',
        dpi: window.devicePixelRatio * 2,
        scale: scale,
        X: 0,
        Y: 0,
        scrollX: -3,
        scrollY: 0,
        useCORS: true,
        allowTaint: true
      }).then(canvas => {
        const url = canvas.toDataURL()
        const a = document.createElement('a')
        a.download = 'Payout_' + (new Date()).getTime()
        const event = new MouseEvent('click')
        a.href = url
        a.dispatchEvent(event)
      })
    },
    onClickCancel() {
      this.changModalStatus(false)
    }
  }
}
</script>
<style scoped lang="scss">
.title{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 31px 10px 25px;
  border-bottom: 1px solid rgba(54, 66, 80, 0.20);
  .title-name{
    display: flex;
    align-items: center;
    color: #488CE8;
    font-size: 16px;
    font-weight: 600;

  }
  .pay-status{
    margin-left: 12px;
    line-height: 25px;
    display: inline-block;
  }
}
.detail-download-container{
  padding :24px;
}

.total{
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;
  .total-item{
    flex: 1;
    padding: 12px;
    border-radius: 8px;
    border: 1px solid rgba(54, 66, 80, 0.20);
    &:nth-child(1){
      margin-right: 24px;
    }
  }
  &-title{
    color: #364250;
    font-size: 12px;
    font-weight: 600;
  }
  &-num{
    margin-top: 12px;
    font-size: 24px;
    font-weight: 600;
    line-height: 1.2;
    color: #488CE8;
  }
}

.item{
  display: flex;
  margin-top: 16px;
  font-size: 12px;
  .item-left{
    display: inline-block;
    width: 250px;
  }
}
.canvas-box{
  position: absolute;
  top: -300vh;
  background: #FFFFFF;
  // display: none;
}

.download-time{
  padding: 12px;
  text-align: center;
  font-size: 13px;
  font-weight: 400;
  color: #488CE8;
  line-height: 1.5;
}

</style>
